import _ from "lodash";
import queryString from "query-string";
import React, {useEffect, useState} from "react";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import BetriebsakteNavigation from "../../components/betriebsakte/BetriebsakteNavigation";
import DateienComponent from "../../components/betriebsakte/common/DateienComponent";
import WiedervorlageFlyByButton from "../../components/betriebsakte/common/WiedervorlageFlyByButton";
import EAFlyByButton from "../../components/EAFlyByButton";
import EAFlyByButtonBar from "../../components/EAFlyByButtonBar";
import {ENTLASTUNG, KANALNETZ} from "../../consts/anlagentyp";
import {betriebstypIdToObj} from "../../consts/betriebstyp";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBA, ZUST_SBB, ZUST_SBD, ZUST_SBS} from "../../consts/funktionaleRollen";
import routes from "../../consts/routes.json";
import {getBetriebKatalogEndpoint} from "../../services/BetriebeService";
import {handleApiException, useHttp} from "../../services/HttpService";
import "../../styles/views/betriebsakte.css";
import {userHasAnyRole} from "../../utils/SecurityUtils";
import {STRING} from "../../utils/URLUtils";
import useQueryParam from "../../utils/useQueryParam";
import {AnforderungenView} from "./AnforderungenView";
import AnlagenDatenView from "./AnlagenDatenView";
import BescheidsdatenView from "./BescheidsdatenView";
import ParameterUebersichtView from "./bescheid/ParameterUebersichtView";
import BetriebsdatenView from "./BetriebsdatenView";
import IndirektEinleiterView from "./IndirektEinleiterView";
import MessstellenDatenView from "./MessstellenDatenView";
import DruckausgabeFlyByButton from "../../components/betriebsakte/common/DruckausgabeFlyByButton";
import MessstellenUebersicht from "../../components/betriebsakte/messstellen/MessstellenUebersicht";
import EntlastungUebersicht from "../../components/betriebsakte/anlagen/EntlastungUebersicht";
import KanalnetzUebersicht from "../../components/betriebsakte/anlagen/KanalnetzUebersicht";
import BescheidUebersichtView from "./bescheid/BescheidUebersichtView";
import {ABWASSERBEHANDLUNG} from "../../consts/anlagenart";
import JahresberichtView from "../../components/betriebsakte/jahresbericht/JahresberichtView";
import JahresberichtDatenView from "../../components/betriebsakte/jahresbericht/JahresberichtDatenView";
import JahresberichtDateien from "../../components/betriebsakte/jahresbericht/JahresberichtDateien";
import MessstellenParameterListe from "../../components/betriebsakte/jahresbericht/MessstellenParameterListe";
import MessstellenParameterDaten from "../../components/betriebsakte/jahresbericht/MessstellenParameterDaten";
import {getJahresberichtEndpoint} from "../../services/AnlagenService";

function BetriebsakteView(props) {
    const [betriebstyp, setBetriebstyp] = useState();
    const [betriebsId, setBetriebsId] = useState();
    const [toggleAllowed, setToggleAllowed] = useState(true);
    const [isHierarchischStillgelegt, setIsHierarchischStillgelegt] = useState(true);
    const [toggleButtonEnabled, setToggleButtonEnabled] = useState(false);
    const [{data: betriebsKatalog, loading: betriebsKatalogLoading}, refetchBetriebsKatalog] = useHttp(
        betriebsId ? getBetriebKatalogEndpoint(betriebsId) : "",
        {
            manual: !betriebsId,
        }
    );

    const [{
        data: jahresberichtData,
        loading: jahresberichtDataLoading
    }, refetchjahresberichte] = useHttp(getJahresberichtEndpoint(betriebsId),{
        manual: !betriebsId,
    });
    const [jahresberichtAnlagen, setJahresberichtAnlagen] = useState([]);

    const location = useLocation();

    /**
     * Falls kein Modus gesetzt wird, wird l als Standard angenommen
     * @type {String}
     */
    const modus = useQueryParam("modus", STRING, "l");

    /**
     * Prüft, ob ein Fachobjekt bearbeitet werden darf und aktiviert entsprechend die Schaltfläche oder navigiert in die "Lesen"-Ansicht
     */
    useEffect(() => {
        if (modus && modus !== "s" && modus !== "l") {
            //falscher Modus gesetzt ( bei keinem Modus wird "l" als Standard angenommen)
            props.history.replace(props.location.pathname + "?modus=l");
        } else if (modus && modus === "s" && (isHierarchischStillgelegt || !toggleAllowed)) {
            //fälschlicherweise Modus s
            props.history.replace(props.location.pathname + "?modus=l");
        } else if (props.location.pathname.includes("/neu/")
            || (props.location.pathname.includes("uebersicht") && !props.location.pathname.includes("entlastung"))
            || props.location.pathname.includes("/indirekteinleiter")
            || isHierarchischStillgelegt
            || !toggleAllowed) {
            setToggleButtonEnabled(false);
        } else {
            setToggleButtonEnabled(true);
        }
    }, [modus, props.history, props.location.pathname, setToggleButtonEnabled, isHierarchischStillgelegt, toggleAllowed]);

    useEffect(() => {
        if (jahresberichtData && jahresberichtAnlagen.length === 0) {
            let updatedJahresberichtAnlagen = [...jahresberichtAnlagen];
            jahresberichtData.forEach((bericht) => {
                let found = false;
                updatedJahresberichtAnlagen.forEach((anlage) => {
                    if (anlage.id === bericht.anlage.id) {
                        found = true;
                    }
                });
                if (!found) {
                    updatedJahresberichtAnlagen.push(bericht.anlage);
                }
            });
            if (updatedJahresberichtAnlagen.length !== 0) {
                setJahresberichtAnlagen(updatedJahresberichtAnlagen);
            }
        }
    }, [jahresberichtData, jahresberichtAnlagen]);

    useEffect(() => {
        const calcedId = isNaN(props.match.params.id) ? null : props.match.params.id;
        if (betriebsId !== calcedId) {
            setBetriebsId(calcedId);
        }
    }, [props.match.params.id, betriebsId]);

    useEffect(() => {
        const {typ: possibleTyp} = queryString.parse(props.location.search);
        if (!betriebsId && possibleTyp) {
            const fullTyp = betriebstypIdToObj(possibleTyp);
            if (!betriebstyp || fullTyp.id !== betriebstyp.id) {
                setBetriebstyp(fullTyp);
            }
        } else if (betriebsKatalog && (!betriebstyp || betriebstyp.id !== betriebsKatalog.betriebstyp.id)) {
            setBetriebstyp(betriebsKatalog.betriebstyp);
        }
    }, [betriebsKatalog, betriebstyp, props.location.search, betriebsId]);

    function reloadNavigation() {
        refetchBetriebsKatalog().catch((e) => handleApiException(e, "Error loading Betriebsakte"));
        refetchjahresberichte().then(() => {
            setJahresberichtAnlagen([]);
        });
    }

    function toggleModus() {
        const hasModus = props.location.search.indexOf("modus") > -1;
        if (modus === "s") {
            props.history.push(props.location.pathname + (hasModus ? _.replace(props.location.search, "modus=s", "modus=l") : "?modus=l"));
        } else {
            props.history.push(props.location.pathname + (hasModus ? _.replace(props.location.search, "modus=l", "modus=s") : "?modus=s"));
        }
    }

    function getToggleIcon() {
        switch (modus) {
            case "l":
                return "ico-edit-flyBy";
            case "s":
                return "ico-view-flyBy";
            default:
                return "ico-edit-flyBy";
        }
    }

    return (
        <>
            <div id="betriebsakteContainer">
                <BetriebsakteNavigation
                    {...props}
                    betriebsId={betriebsId}
                    betriebstyp={betriebstyp}
                    modus={modus}
                    navObject={betriebsKatalog}
                    loading={betriebsKatalogLoading}
                    setIsHierarchischStillgelegt={setIsHierarchischStillgelegt}
                    jahresberichtData={jahresberichtData}
                    jahresberichtDataLoading={{jahresberichtDataLoading}}
                    jahresberichtAnlagen={jahresberichtAnlagen}
                />
                {betriebstyp && (
                    <Switch>
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BETRIEBSDATEN}
                            render={(innerProps) => (
                                <BetriebsdatenView
                                    betriebstyp={betriebstyp}
                                    betriebsId={betriebsId}
                                    modus={modus}
                                    {...innerProps}
                                    reloadNavigation={reloadNavigation}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_DATEIEN}>
                            <DateienComponent modus={modus} setToggleAllowed={setToggleAllowed}/>
                        </Route>
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BESCHEIDE_WITH_ID_BESCHEIDDATEN}
                            render={(innerProps) => (
                                <BescheidsdatenView
                                    betriebsId={betriebsId}
                                    modus={modus}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                    key={props.location.pathname} // Hotfix für das Forcieren eines kompletten Reloads
                                />
                            )}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANTRAEGE_WITH_ID}
                            render={(innerProps) => (
                                <BescheidsdatenView
                                    betriebsId={betriebsId}
                                    modus={modus}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANTRAG_DATEIEN}>
                            <DateienComponent modus={modus} setToggleAllowed={setToggleAllowed}/>
                        </Route>
                        <Route path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BESCHEID_DATEIEN}>
                            <DateienComponent modus={modus} setToggleAllowed={setToggleAllowed}/>
                        </Route>
                        <Route path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BESCHEID_MESSSTELLE}>
                            <AnforderungenView
                                betriebstyp={betriebstyp}
                                modus={modus}
                                reloadNavigation={reloadNavigation}
                                setToggleAllowed={setToggleAllowed}
                            />
                        </Route>
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_PARAMETERUEBERSICHT}
                            render={(innerProps) => (
                                <ParameterUebersichtView betriebsId={betriebsId} {...innerProps} setToggleAllowed={setToggleAllowed}/>
                            )}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BESCHEIDUEBERSICHT}
                            render={(innerProps) => (
                                <BescheidUebersichtView betriebsId={betriebsId} {...innerProps} setToggleAllowed={setToggleAllowed}/>
                            )}
                        />
                        <Route path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANTRAG_MESSSTELLE}>
                            <AnforderungenView
                                betriebstyp={betriebstyp}
                                modus={modus}
                                reloadNavigation={reloadNavigation}
                                setToggleAllowed={setToggleAllowed}
                            />
                        </Route>
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_INDIREKTEINLEITER_WITH_ID}
                            exact
                            component={IndirektEinleiterView}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANLAGENDATEN_WITH_ID}
                            exact
                            render={(innerProps) => (
                                <AnlagenDatenView
                                    reloadNavigation={reloadNavigation}
                                    betriebstyp={betriebstyp}
                                    betriebsId={betriebsId}
                                    modus={modus}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                    key={location.pathname}
                                    anlagentyp={ABWASSERBEHANDLUNG}
                                />
                            )}
                        />
                        <Route path={routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANLAGEDATEIEN}>
                            <DateienComponent modus={modus} setToggleAllowed={setToggleAllowed}/>
                        </Route>
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/:parentanlageid/" +
                                KANALNETZ.toLowerCase() +
                                routes.BETRIEBSAKTE_ANLAGENDATEN_WITH_ID
                            }
                            exact
                            render={(innerProps) => (
                                <AnlagenDatenView
                                    reloadNavigation={reloadNavigation}
                                    betriebstyp={betriebstyp}
                                    betriebsId={betriebsId}
                                    modus={modus}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                    key={location.pathname}
                                    anlagentyp={KANALNETZ}
                                />
                            )}
                        />
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/:parentanlageid/" +
                                KANALNETZ.toLowerCase() +
                                routes.BETRIEBSAKTE_ANLAGEDATEIEN
                            }
                        >
                            <DateienComponent modus={modus} setToggleAllowed={setToggleAllowed}/>
                        </Route>
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/" +
                                ENTLASTUNG.toLowerCase() +
                                routes.BETRIEBSAKTE_ANLAGENDATEN_WITH_ID
                            }
                            exact
                            render={(innerProps) => (
                                <AnlagenDatenView
                                    reloadNavigation={reloadNavigation}
                                    betriebstyp={betriebstyp}
                                    betriebsId={betriebsId}
                                    modus={modus}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                    key={location.pathname}
                                    anlagentyp={ENTLASTUNG}
                                />
                            )}
                        />
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/" +
                                ENTLASTUNG.toLowerCase() +
                                routes.BETRIEBSAKTE_ANLAGEDATEIEN
                            }
                        >
                            <DateienComponent modus={modus} setToggleAllowed={setToggleAllowed}/>
                        </Route>
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + "/:anlageid" + routes.BETRIEBSAKTE_MESSSTELLEN_UEBERSICHT}
                            exact
                            render={(innerProps) => (
                                <MessstellenUebersicht {...innerProps}/>
                            )}
                        />
                        <Route

                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/:parentanlageid/" +
                                KANALNETZ.toLowerCase() +
                                "/:anlageid" +
                                routes.BETRIEBSAKTE_MESSSTELLEN_UEBERSICHT
                            }
                            exact
                            render={(innerProps) => (
                                <MessstellenUebersicht {...innerProps}/>
                            )}
                        />
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/" +
                                ENTLASTUNG.toLowerCase() +
                                "/:anlageid" +
                                routes.BETRIEBSAKTE_MESSSTELLEN_UEBERSICHT
                            }
                            exact
                            render={(innerProps) => (
                                <MessstellenUebersicht {...innerProps}/>
                            )}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + "/:anlageid" + routes.BETRIEBSAKTE_MESSSTELLEN}
                            exact
                            render={(innerProps) => (
                                <MessstellenDatenView
                                    modus={modus}
                                    betriebstyp={betriebstyp}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + "/jahresbericht/:berichtid/messstelle/:messstellenid"}
                            exact
                            render={(innerProps) => (
                                <MessstellenParameterListe
                                    modus={modus}
                                    betriebstyp={betriebstyp}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                    betriebsId={betriebsId}
                                />
                            )}
                        />
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/:parentanlageid/" +
                                KANALNETZ.toLowerCase() +
                                "/:anlageid" +
                                routes.BETRIEBSAKTE_MESSSTELLEN
                            }
                            exact
                            render={(innerProps) => (
                                <MessstellenDatenView
                                    modus={modus}
                                    betriebstyp={betriebstyp}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route
                            path={
                                routes.BETRIEBSAKTE_WITH_ID +
                                "/" +
                                ENTLASTUNG.toLowerCase() +
                                "/:anlageid" +
                                routes.BETRIEBSAKTE_MESSSTELLEN
                            }
                            exact
                            render={(innerProps) => (
                                <MessstellenDatenView
                                    modus={modus}
                                    betriebstyp={betriebstyp}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route
                            path={"*/entlastung/uebersicht/"}
                            render={(innerProps) => (
                                <EntlastungUebersicht modus={modus} reloadNavigation={reloadNavigation} {...innerProps} betriebsId={betriebsId}/>
                            )}
                        />
                        <Route
                            path={"*/kanalnetz/uebersicht/:parentanlageid"}
                            render={(innerProps) => (
                                <KanalnetzUebersicht {...innerProps}/>
                            )}
                        />
                        <Route
                            path={"*/jahresbericht/uebersicht/"}
                            render={(innerProps) => (
                                <JahresberichtView
                                    modus={modus}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    betriebsId={betriebsId}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.JAHRESBERICHT + routes.JAHRESBERICHTDATEN_WITH_ID}
                            render={(innerProps) => (
                                <JahresberichtDatenView
                                    modus={modus}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    betriebsId={betriebsId}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route
                            path={routes.BETRIEBSAKTE_WITH_ID + routes.JAHRESBERICHT + routes.BERICHT_ID + routes.BETRIEBSAKTE_DATEIEN}
                            render={(innerProps) => (
                                <JahresberichtDateien
                                    modus={modus}
                                    reloadNavigation={reloadNavigation}
                                    {...innerProps}
                                    betriebsId={betriebsId}
                                    setToggleAllowed={setToggleAllowed}
                                />
                            )}
                        />
                        <Route
                            path={routes.JAHRESBERICHT_PARAMETER_MESSWERTE}
                            render={(innerProps) => (
                                <MessstellenParameterDaten
                                    modus={modus}
                                    jahresberichtData={jahresberichtData}
                                    reloadNavigation={reloadNavigation}
                                    betriebsId={betriebsId}
                                />
                            )}
                        />
                        <Redirect
                            from={routes.BETRIEBSAKTE_WITH_ID}
                            exact
                            to={`${routes.BETRIEBSAKTE_RAW}/${props.match.params.id}${routes.BETRIEBSAKTE_BETRIEBSDATEN}${props.location.search}`}
                        />
                        <Redirect exact from={routes.BETRIEBSAKTE_RAW} to="/"/>
                    </Switch>
                )}
            </div>
            <EAFlyByButtonBar>
                {toggleButtonEnabled && (
                    <EAFlyByButton
                        label={"Zwischen lesendem und bearbeitendem Modus wechseln"}
                        loading={betriebsKatalogLoading}
                        onClick={toggleModus}
                        id={"toggleedit"}
                        iconName={getToggleIcon()}
                    />
                )}
                <Route
                    exact
                    path={[
                        routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BETRIEBSDATEN, //Betriebsdaten
                        routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANLAGENDATEN_WITH_ID, //Betrieb ->Anlagendaten
                        routes.BETRIEBSAKTE_WITH_ID +
                        "/" +
                        ENTLASTUNG.toLowerCase() +
                        routes.BETRIEBSAKTE_ANLAGENDATEN_WITH_ID, //Betrieb ->Anlage -> Entlastung ->Anlagendaten
                        routes.BETRIEBSAKTE_WITH_ID +
                        "/:parentanlageid/" +
                        KANALNETZ.toLowerCase() +
                        routes.BETRIEBSAKTE_ANLAGENDATEN_WITH_ID, //Betrieb ->Anlage -> Kanalnetz ->Anlagendaten
                        routes.BETRIEBSAKTE_WITH_ID + "/:anlageid" + routes.BETRIEBSAKTE_MESSSTELLEN, //Betrieb -> Anlage -> Messstellendaten
                        routes.BETRIEBSAKTE_WITH_ID +
                        "/:parentanlageid/" +
                        KANALNETZ.toLowerCase() +
                        "/:anlageid" +
                        routes.BETRIEBSAKTE_MESSSTELLEN, //Betrieb -> Anlage -> Kanalnetz -> Anlage -> Messstellendaten
                        routes.BETRIEBSAKTE_WITH_ID +
                        "/:parentanlageid/" +
                        ENTLASTUNG.toLowerCase() +
                        "/:anlageid" +
                        routes.BETRIEBSAKTE_MESSSTELLEN, //Betrieb -> Anlage -> Entlastung -> Anlage -> Messstellendaten
                        routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BESCHEIDE_WITH_ID_BESCHEIDDATEN, //Betrieb -> Bescheidsdaten
                        routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ANTRAEGE_WITH_ID, //Betrieb -> Bescheidsdaten
                        routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_BESCHEID_MESSSTELLE,
                        routes.BETRIEBSAKTE_WITH_ID + routes.BETRIEBSAKTE_ENTLASTUNG_WITH_ID + routes.BETRIEBSAKTE_MESSSTELLEN
                    ]}
                >
                    {!props.location.pathname.includes("/neu") &&
                        userHasAnyRole([SYSTEMADMIN, FACHADMIN, BETREIBER, BEAUFTRAGTER, ZUST_SBD, ZUST_SBB, ZUST_SBS, ZUST_SBA]) && (
                            <WiedervorlageFlyByButton/>
                        )}
                    {!props.location.pathname.includes("/neu") && (
                        <DruckausgabeFlyByButton navTree={betriebsKatalog} navTreeLoading={betriebsKatalogLoading}/>
                    )}
                </Route>
            </EAFlyByButtonBar>
        </>
    );
}

export default BetriebsakteView;
